import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactExpertComponent } from './contact-expert.component';
import { TranslocoModule } from '@ngneat/transloco';
import { SvgIconsModule } from '../svg';

@NgModule({
  declarations: [ContactExpertComponent],
  imports: [CommonModule, TranslocoModule, SvgIconsModule],
  exports: [ContactExpertComponent],
})
export class ContactExpertModule {}
